import { useEffect } from 'react';

// For most DOM events there won't be a practical difference between document and window events
// But it may come up.
//
// apparently addEventListener won't add duplicate listeners for same function reference

export function useDocumentEventListener(
  eventName: keyof DocumentEventMap,
  callback: (event: Event) => void
) {
  useEffect(() => {
    window.document.addEventListener(eventName, callback);

    return () => {
      window.document.removeEventListener(eventName, callback);
    };
  }, [eventName, callback]);
}

export function useWindowEventListener(
  eventName: keyof WindowEventMap,
  callback: (event: Event) => void
) {
  useEffect(() => {
    window.addEventListener(eventName, callback);

    return () => {
      window.removeEventListener(eventName, callback);
    };
  }, [eventName, callback]);
}